import { Injectable, inject } from "@angular/core";

import { CustomComponentRegistry, CustomViewItem, CUSTOM_VIEW_REGISTRY, } from "./interfaces";
type CustomViewRegistry = Record<string, CustomViewItem>;

@Injectable()
export class CustomViewService
{
    private readonly items: Readonly<CustomViewRegistry>;

    constructor()
    {
        const customComponentRegistries = inject<ReadonlyArray<Readonly<CustomComponentRegistry>>>(CUSTOM_VIEW_REGISTRY);

        this.items = customComponentRegistries
            ? customComponentRegistries.reduce((r: CustomViewRegistry, componentRegistry: CustomComponentRegistry) =>
            {
                for (const selector in componentRegistry)
                {
                    r[selector] = new CustomViewItem(componentRegistry[selector]);
                }
                return r;
            }, <CustomViewRegistry>{})
            : {};
    }

    getView<T = unknown>(name: string): CustomViewItem<T>
    {
        return this.items[name] as CustomViewItem<T>;
    }

    hasView(name: string): boolean
    {
        return !!this.items[name];
    }
}

